// extracted by mini-css-extract-plugin
export default {"Container":"taskItem_Container__o18n4"};